<template>
    <div class="spinner" :style="{ minHeight: `${minHeight}vh` }">
        <div class="bounce1 mx-1"></div>
        <div class="bounce2 mx-1"></div>
        <div class="bounce3 mx-1"></div>
    </div>
</template>

<script>
export default {
    props: {
        minHeight: {
            type: Number,
            default: 60,
        },
    },
};
</script>

<style>
.spinner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.spinner>div {
    width: 15px;
    height: 15px;
    background-color: #a50e3b;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0)
    }

    40% {
        -webkit-transform: scale(1.0)
    }
}

@keyframes sk-bouncedelay {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}
</style>